import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { environment } from '@pt/environment';
import { UiStore } from '@pt/services';

@Component({
  selector: 'pu-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LottieComponent],
})
export class SpinnerComponent {
  readonly #uiStore = inject(UiStore);
  readonly isTwOrEdOther = ['tw', 'ta-tw', 'ta-ed'].includes(environment.shortName);

  readonly options = computed<AnimationOptions>(() => {
    return {
      path: this.#uiStore.isDarkTheme()
        ? '/assets/app-images/spinner-dark.json'
        : '/assets/app-images/spinner-light.json',
    };
  });
}
